import { render, staticRenderFns } from "./TestimonialSlider.vue?vue&type=template&id=17b1797b&"
import script from "./TestimonialSlider.vue?vue&type=script&lang=js&"
export * from "./TestimonialSlider.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports